import { render, staticRenderFns } from "./TerrainInvitationExchange.vue?vue&type=template&id=9ea15524&scoped=true"
import script from "./TerrainInvitationExchange.vue?vue&type=script&lang=js"
export * from "./TerrainInvitationExchange.vue?vue&type=script&lang=js"
import style0 from "./TerrainInvitationExchange.vue?vue&type=style&index=0&id=9ea15524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea15524",
  null
  
)

export default component.exports